import { DataHeader, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutZoneSuperRegion extends Layout {
    dataheaderZoneSuperRegion: DataHeader;
    panelZoneSuperRegion: Panel;
    sourceZoneSuperRegion: DataSource;
    textboxDescription: Textbox;
    textboxId: Textbox;
}
